import React, { useEffect, useState, useRef } from 'react';
function ZoomableDiv({
  children,
  zoomFactor = 2,
  magnifierSize = 150,
  isZoomEnabled,
  overflowVisibleWhenIdle = false,
}) {
  const [isHovering, setIsHovering] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setContainerSize({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight,
        });
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    const observer = new ResizeObserver(handleResize);
    const element = containerRef.current;
    if (element) {
      observer.observe(element);
    }
    return () => {
      window.removeEventListener('resize', handleResize);
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);
  const handleMouseMove = (e) => {
    if (containerRef.current) {
      const { left, top } = containerRef.current.getBoundingClientRect();
      const x = e.clientX - left;
      const y = e.clientY - top;
      setMousePosition({ x, y });
    }
  };
  const zoomedContentStyle = {
    transform: `scale(${zoomFactor})`,
    transformOrigin: '0% 0%',
    position: 'absolute',
    left: `${-mousePosition.x * zoomFactor + magnifierSize / 2}px`,
    top: `${-mousePosition.y * zoomFactor + magnifierSize / 2}px`,
    width: contentRef.current ? `${contentRef.current.offsetWidth}px` : `${containerSize.width}px`,
    height: contentRef.current
      ? `${contentRef.current.offsetHeight}px`
      : `${containerSize.height}px`,
    visibility: 'visible',
    opacity: 1,
    boxSizing: 'border-box',
  };
  const magnifierStyle = {
    position: 'absolute',
    width: `${magnifierSize}px`,
    height: `${magnifierSize}px`,
    borderRadius: '50%',
    border: '2px solid var(--zoom-border, #61dafb)',
    boxShadow: '0 0 10px rgba(0,0,0,0.2)',
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: 10,
    left: `${mousePosition.x - magnifierSize / 2}px`,
    top: `${mousePosition.y - magnifierSize / 2}px`,
    transform: 'translateZ(0)',
  };
  return (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        // Con zoom apagado no hay lupa que recortar, así que dejamos sobresalir
        // tooltips/carteles que se dibujan fuera del SVG (opt-in por prop).
        overflow: overflowVisibleWhenIdle && !isZoomEnabled ? 'visible' : 'hidden',
        zIndex: 1000,
        boxSizing: 'border-box',
      }}
      onMouseEnter={isZoomEnabled ? () => setIsHovering(true) : null}
      onMouseLeave={isZoomEnabled ? () => setIsHovering(false) : null}
      onMouseMove={isZoomEnabled ? handleMouseMove : null}
    >
      {}
      <div ref={contentRef} style={{ width: '100%', height: '100%', display: 'flex' }}>
        {children}
      </div>
      {isHovering && isZoomEnabled && (
        <div style={magnifierStyle}>
          <div style={zoomedContentStyle}>{children}</div>
        </div>
      )}
    </div>
  );
}
export default ZoomableDiv;
